module.exports = __webpack_public_path__ + "static/media/learning-11.0fdced40.png";